import { FadeIn } from '../../components/AnimateIn'
import Button from '../../components/Button'
import Section from '../../components/Section'
import { Text } from '../../components/Text'

interface Props {
  onContainerRef?: (node: HTMLDivElement) => void
}

export default function Location({ onContainerRef }: Props) {
  return (
    <div ref={onContainerRef} className='flex flex-col md:flex-row lg:min-h-[700px]'>
      <Section
        withVerticalPadding
        className='flex flex-2 flex-col md:flex-row gap-11 md:gap-24 lg:gap-36'
      >
        <div className='flex flex-col gap-11'>
          <FadeIn delay={0.2}>
            <Text.H2>Location</Text.H2>
          </FadeIn>
          <FadeIn delay={0.4}>
            <Text.Body>
              <p>The Brethren Assembly Dubai</p>
              <p>Holy Trinity Church</p>
              <p>Opp. to Iranian Club</p>
              <p>Oud Metha Road</p>
              <p>Dubai, UAE</p>
            </Text.Body>
          </FadeIn>
          <FadeIn delay={0.6}>
            <div className='flex'>
              <Button
                variant='outline'
                icon='Map'
                href='https://maps.app.goo.gl/o1xwjFLrcJXA32oK6'
                target='_blank'
              >
                Open In Map
              </Button>
            </div>
          </FadeIn>
        </div>
      </Section>
      <iframe
        src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.9784327919197!2d55.31537787813029!3d25.23765137768499!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5dc038ada1cd%3A0x103ff57ec88fe074!2sHoly%20Trinity%20Church!5e0!3m2!1sen!2sin!4v1733661178786!5m2!1sen!2sin'
        className="flex flex-1 min-h-[500px] md:min-h-max bg-cover bg-bottom bg-[url('assets/map.png')] shadow-md"
        loading='lazy'
      />
    </div>
  )
}
